import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
// import DownloadIcon from 'remixicon-react/DownloadLineIcon';

const FinancialsPage: NextPage = () => {
  return (
    <>
      <NextSeo
        title="Financials | PrishaPolicy"
        description="Explore PrishaPolicy's financial reports, audit certificates, and other corporate disclosures."
      />
      <div className="container py-12 px-4 my-15">
        <header className="text-center mb-12">
          <h1 className="text-title-2 font-semibold text-primary">Financial Disclosures</h1>
          <p className="text-body-1 text-grey-700 mt-4 max-w-3xl mx-auto">
            Access our annual financial statements from the last five years to stay informed about our company’s
            performance.
          </p>
        </header>

        <section id="annual-reports" className="mt-16">
          <div className="wrap">
            <h2 className="text-title-3 font-semibold text-primary">Annual Reports</h2>
            <p className="text-body-1 text-grey-700 mt-2">
              Business performance, operations, and audited statements for the respective financial year.
            </p>
            <div className="years mt-6" role="list">
              <div
                className="year-item py-4 border-b border-grey-200 flex justify-between items-center"
                role="listitem"
                data-year="2024-25"
              >
                <a
                  href="https://prishapolicy-my.sharepoint.com/:f:/p/akshat_jain/EjjELGgF3iBDiwQcjtYodb8BYcUNFU7SZKrYuln_F2bbBQ?e=f8VjNG"
                  target="_blank"
                  rel="noreferrer"
                  className="text-body-1 text-primary hover:underline"
                >
                  Annual Report FY 2024–25
                </a>
                <span className="note text-body-3 text-grey-600">View on SharePoint</span>
              </div>
              <div
                className="year-item py-4 border-b border-grey-200 flex justify-between items-center"
                role="listitem"
                data-year="2023-24"
              >
                <a
                  href="https://prishapolicy-my.sharepoint.com/:f:/p/akshat_jain/EjjELGgF3iBDiwQcjtYodb8BYcUNFU7SZKrYuln_F2bbBQ?e=f8VjNG"
                  target="_blank"
                  rel="noreferrer"
                  className="text-body-1 text-primary hover:underline"
                >
                  Annual Report FY 2023–24
                </a>
                <span className="note text-body-3 text-grey-600">View on SharePoint</span>
              </div>
              <div
                className="year-item py-4 border-b border-grey-200 flex justify-between items-center"
                role="listitem"
                data-year="2022-23"
              >
                <a
                  href="https://prishapolicy-my.sharepoint.com/:f:/p/akshat_jain/EjjELGgF3iBDiwQcjtYodb8BYcUNFU7SZKrYuln_F2bbBQ?e=f8VjNG"
                  target="_blank"
                  rel="noreferrer"
                  className="text-body-1 text-primary hover:underline"
                >
                  Annual Report FY 2022–23
                </a>
                <span className="note text-body-3 text-grey-600">View on SharePoint</span>
              </div>
              <div
                className="year-item py-4 border-b border-grey-200 flex justify-between items-center"
                role="listitem"
                data-year="2021-22"
              >
                <a
                  href="https://prishapolicy-my.sharepoint.com/:f:/p/akshat_jain/EjjELGgF3iBDiwQcjtYodb8BYcUNFU7SZKrYuln_F2bbBQ?e=f8VjNG"
                  target="_blank"
                  rel="noreferrer"
                  className="text-body-1 text-primary hover:underline"
                >
                  Annual Report FY 2021–22
                </a>
                <span className="note text-body-3 text-grey-600">View on SharePoint</span>
              </div>
              <div
                className="year-item py-4 border-b border-grey-200 flex justify-between items-center"
                role="listitem"
                data-year="2020-21"
              >
                <a
                  href="https://prishapolicy-my.sharepoint.com/:f:/p/akshat_jain/EjjELGgF3iBDiwQcjtYodb8BYcUNFU7SZKrYuln_F2bbBQ?e=f8VjNG"
                  target="_blank"
                  rel="noreferrer"
                  className="text-body-1 text-primary hover:underline"
                >
                  Annual Report FY 2020–21
                </a>
                <span className="note text-body-3 text-grey-600">View on SharePoint</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FinancialsPage;
